<template>
  <div id="services" class="mb-5">
    <div class="card mb-3 mt-3">
      <div class="card-body">
        <h4 class="text-center mb-4">{{ translate('suppliers.services') }}</h4>
        <div class="row">
          <div class="col-6 col-md-2" v-for="(value, index) in services" :key="index">
            <ServiceBox :content="{ name: value.name }" />
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="card-body">
        <h4 class="text-center mb-4">{{ translate('services.special_services') }}</h4>
        <div class="row">
          <div class="col-6 col-md-2" v-for="(value, index) in specialServices" :key="index">
            <ServiceBox :content="{ name: value.name }" />
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="card-body">
        <h4 class="text-center mb-4">{{ translate('services.target_regions') }}</h4>
        <div class="row">
          <div class="col-6 col-md-2" v-for="(value, index) in targetRegions" :key="index">
            <ServiceBox :content="{ name: value.value }" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceBox from "../services/ServiceBox";
export default {
  name: "Services",
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  components: {
    ServiceBox
  },
  data() {
    return {
      services: [],
      specialServices: [],
      targetRegions: []
    };
  },
  mounted() {
    this.services = this.data.services;
    this.specialServices = this.data.special_services;
    this.targetRegions = this.data.target_regions;
  }
};
</script>

<style scoped lang="scss">
.list-group-item {
  padding-left: 0px !important;
}
</style>